import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Normalize VITE_API_URL: strip trailing /api if already present, then re-add it.
// Robust whether the build arg is passed with or without /api suffix.
const _apiBase = (import.meta.env.VITE_API_URL || 'http://localhost:8002')
  .replace(/\/api\/?$/, '').replace(/\/$/, '') + '/api';

export const apiSlice = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: _apiBase,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    }
  }),
  tagTypes: [
    'Member',
    'GameRun',
    'Groupe',
    'MembreGroupe',
    'GameIsland',
    'GamePoint',
    'Version',
    'Scale',
    'GameExample',
    'Enterprise',
    'GameGroupMember',
    'UserMember',
    'UserEnterprise',
  ],
  endpoints: builder => ({})

});
